import React, {useEffect, useRef, useState} from 'react';
import {RelationshipApiClient} from '../../../../../common/apis/relationship/RelationshipApiClient';
import {RelationshipDto} from '../../../../../common/apis/relationship/RelationshipDto';
import {ButtonLayout, NegativeButtons, PositiveButtons} from '../../../../../components/button/ButtonLayout';
import {CancelButton} from '../../../../../components/button/CancelButton';
import {SaveButton} from '../../../../../components/button/SaveButton';
import Dialog from '../../../../../components/dialogs/Dialog';
import DialogActions from '../../../../../components/dialogs/DialogActions';
import DialogContent from '../../../../../components/dialogs/DialogContent';
import DialogTitle from '../../../../../components/dialogs/DialogTitle';
import Grid from '../../../../../components/dialogs/Grid';
import TextField from '../../../../../components/fields/textfield/TextField';
import {t} from '../../../../../store/localization/TranslMessasge';
import {CommonTranslationKey} from "../../CommonTranslationKey";
import {ErrorTranslationKey} from '../../ErrorTranslationKey';
import Snackbar from '../../snackbar/Snackbar';
import {RelationshipsTranslationKey} from '../RelationshipsTranslationKey';

interface RelationshipUpdateDialogProps {
    open: boolean;
    relationship: RelationshipDto;
    onUpdated: () => void;
    onClose: () => void;
}

export function RelationshipUpdateDialog({open, relationship, onUpdated, onClose}: Readonly<RelationshipUpdateDialogProps>) {
    const relationshipApiClient = useRef(new RelationshipApiClient());

    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [inProgress, setInProgress] = useState(false);

    useEffect(() => {
        if (open) {
            setName(relationship.name ?? '');
            setDescription(relationship.description ?? '');
        }
    }, [open, relationship]);

    function updateRelationship() {
        setInProgress(true);

        relationshipApiClient.current.updateRelationship(relationship.identifier, {
            name: name.trim(),
            description: description.trim(),
        })
                .then(() => {
                    onUpdated();
                    onClose();
                    Snackbar.success(t(CommonTranslationKey.DATA_SAVED_SUCCESSFULLY));
                })
                .catch((error) => Snackbar.error(t(ErrorTranslationKey.UNEXPECTED_ERROR_OCCURRED), error))
                .finally(() => setInProgress(false));
    }

    return (
            <Dialog open={open} onClose={onClose} maxWidth="md">
                <DialogTitle title={t(RelationshipsTranslationKey.EDIT_RELATIONSHIP_DETAILS)}
                        onDialogClosed={onClose}/>
                <DialogContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <TextField
                                    label={t(RelationshipsTranslationKey.NAME)}
                                    value={name}
                                    onChange={value => setName(value)}/>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                    label={t(CommonTranslationKey.DESCRIPTION)}
                                    value={description}
                                    onChange={value => setDescription(value)}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <ButtonLayout>
                        <PositiveButtons>
                            <SaveButton onClick={updateRelationship} disabled={inProgress}/>
                        </PositiveButtons>
                        <NegativeButtons>
                            <CancelButton onClick={onClose} disabled={inProgress}/>
                        </NegativeButtons>
                    </ButtonLayout>
                </DialogActions>
            </Dialog>
    );
}
